require('./bootstrap');

/**
 * Autocomplete
 */
window['$autocomplete'] = {}
for (const elm of document.querySelectorAll('input.autocomplete[type=search]')) {
    if (!elm.id)
        elm.id = `autocomplete-${Math.random().toString(36).substring(2)}`
    window['$autocomplete'][elm.id] = new Autocomplete(elm)
}
